<template>
    <div class="flex flex-col sm:flex-row sm:items-end">
        <input-date
            :name="'tenant[' + tenant.id + '][right_to_renew_at]'"
            v-model="right_to_renew_at"
            @entered="dateEntered"
            :read_only="read_only"
        />

        <div class="sm:mt-0 flex items-center">
            <span class="text-sm text-gray-warm-800 sm:pl-6 pr-6">
                {{ $t('- OR -') }}
            </span>

            <div class="w-16 sm:w-1/5">
                <input-text
                    :name="'tenant[' + tenant.id + '][right_to_renew_period]'"
                    v-model="right_to_renew_period"
                    placeholder="Days"
                    :read_only="read_only"
                />
            </div>

            <span class="text-sm text-gray-warm-800 leading-snug w-36 pl-4">
                {{ $t('days before termination date') }}
            </span>
        </div>
    </div>
</template>

<script>
import DateFunctions from '../../../mixins/date-functions.js';

export default {
    mixins: [
        DateFunctions,
    ],

    props: {
        read_only: { default: false },
        tenant: {},
    },

    data() {
        return {
            right_to_renew_at: this.tenant.right_to_renew_at,
            right_to_renew_period: this.tenant.right_to_renew_period,
        }
    },

    computed: {
        right_to_renew_from_period() {
            if (! this.tenant.lease_terminates_at) {
                return;
            }

            if (this.isValidDate(this.tenant.lease_terminates_at) && this.right_to_renew_period) {
                return dayjs(this.tenant.lease_terminates_at.slice(0, 10))
                    .subtract({ day: this.right_to_renew_period })
                    .format('YYYY-MM-DD');
            }
        },
    },

    methods: {
        dateEntered() {
            this.right_to_renew_period = null;
        },
    },

    watch: {
        right_to_renew_from_period(val) {
            if (val) {
                this.right_to_renew_at = val;
            }
        },
    },
}
</script>
